import {
  ChangeDetectionStrategy,
  Component,
  Input,
  SecurityContext
} from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-video-player-modal',
  templateUrl: './video-player-modal.component.html',
  styleUrl: './video-player-modal.component.less',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class VideoPlayerModalComponent {
  constructor(
    private ActiveModal: NgbActiveModal,
    private ToastService: ToastService,
    private DomSanitizer: DomSanitizer
  ) {}

  @Input() IFrameOptions!: {
    src: SafeUrl;
    style: string;
    title: string;
  };

  close() {
    this.ActiveModal.dismiss();
  }

  ngOnInit(): void {
    if (!this.IFrameOptions) {
      throw this.ToastService.addErrorToast(
        'Error',
        'Missing IFrame options.',
        { returnError: true }
      );
    }

    Object.assign(this.IFrameOptions, {
      src: this.DomSanitizer.bypassSecurityTrustResourceUrl(
        this.DomSanitizer.sanitize(
          SecurityContext.URL,
          this.IFrameOptions.src
        ) || ''
      )
    });
  }
}
